const defaultPayrollState = {
  payrollListData: null,
  payrollDetailsData: null,
  selectedPayroll: null,
  onResetSelectedPayroll: () => {},
  onSelectPayroll: () => {},
  loadingState: {
    isLoadingPayrollListData: false,
    isLoadingPayrollDetails: false,
  },
  errorState: {
    payrollListDataError: undefined,
    payrollDetailsError: undefined,
  },
};

export { defaultPayrollState };
